import { AIButtonContainedDark as AIButtonContainedDarkButton } from '../../AIButton'
import { Container } from '../Container'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

export function AIButtonContainedDark() {
  return (
    <>
      <Container label='AI Button, contained dark, sizes - 32px'>
        <AIButtonContainedDarkButton text='Button' />
      </Container>
      <Container label='AI Button, contained dark, disabled, sizes - 32px'>
        <AIButtonContainedDarkButton disabled text='Button' />
      </Container>
      <Container label='AI Button, contained dark, with loader, sizes - 32px'>
        <AIButtonContainedDarkButton isLoading text='Button' />
      </Container>
      <Container label='AI Button, contained dark, with pre icon, sizes - 32px'>
        <AIButtonContainedDarkButton
          beforeIconProps={{ Icon: PlusIcon }}
          text='Button'
        />
      </Container>
      <Container label='AI Button, contained dark, with pre icon, with loader, sizes - 32px'>
        <AIButtonContainedDarkButton
          isLoading
          beforeIconProps={{ Icon: PlusIcon }}
          text='Button'
        />
      </Container>
      <Container label='AI Button, contained dark, with post icon, sizes - 32px'>
        <AIButtonContainedDarkButton
          afterIconProps={{ Icon: EditIcon }}
          text='Button'
        />
      </Container>
      <Container label='AI Button, contained dark, with post icon, with loader, sizes - 32px'>
        <AIButtonContainedDarkButton
          isLoading
          afterIconProps={{ Icon: EditIcon }}
          text='Button'
        />
      </Container>
      <Container label='AI Button, contained dark, with skeleton, sizes - 32px'>
        <AIButtonContainedDarkButton isSkeleton text='Button' />
      </Container>
      <Container label='AI Button, contained dark, icon, sizes - 32px'>
        <AIButtonContainedDarkButton beforeIconProps={{ Icon: PlusIcon }} />
      </Container>
      <Container label='AI Button, contained dark, icon, disabled, sizes - 32px'>
        <AIButtonContainedDarkButton
          disabled
          beforeIconProps={{ Icon: PlusIcon }}
        />
      </Container>
      <Container label='AI Button, contained dark, icon, with loader, sizes - 32px'>
        <AIButtonContainedDarkButton
          isLoading
          beforeIconProps={{ Icon: PlusIcon }}
        />
      </Container>
      <Container label='AI Button, contained dark, icon, with skeleton, sizes - 32px'>
        <AIButtonContainedDarkButton
          isSkeleton
          beforeIconProps={{ Icon: PlusIcon }}
        />
      </Container>
      <Container label='AI Button, contained dark, circle icon, sizes - 32px'>
        <AIButtonContainedDarkButton
          isCircle
          beforeIconProps={{ Icon: PlusIcon }}
        />
      </Container>
      <Container label='AI Button, contained dark, circle icon, disabled, sizes - 32px'>
        <AIButtonContainedDarkButton
          disabled
          isCircle
          beforeIconProps={{ Icon: PlusIcon }}
        />
      </Container>
      <Container label='AI Button, contained dark, circle icon, with loader, sizes - 32px'>
        <AIButtonContainedDarkButton
          isCircle
          isLoading
          beforeIconProps={{ Icon: PlusIcon }}
        />
      </Container>
      <Container label='AI Button, contained dark, circle icon, with skeleton, sizes - 32px'>
        <AIButtonContainedDarkButton
          isCircle
          isSkeleton
          beforeIconProps={{ Icon: PlusIcon }}
        />
      </Container>
    </>
  )
}
